<payee-chip-dropdown
  [displayWith]="displayWith"
  [placeholder]="'CASES_TABLE.FILTERS.CLIENT.LABEL' | translate"
  [selected]="client"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="clearFilter()"
>
  <payee-form-field>
    <payee-autocomplete
      placeholder="{{ 'CASES_TABLE.FILTERS.CLIENT.PLACEHOLDER' | translate }}"
      [options]="clientOptions"
      [formControl]="clientControl"
      [displayWith]="displayWith"
      (searchChange)="onSearchChange($event)"
    ></payee-autocomplete>
  </payee-form-field>
</payee-chip-dropdown>
